export function Logo({ className = "", size = "text-2xl", withDot = true, dark = false, testid }) {
  return (
    <span data-testid={testid} className={`font-display font-extrabold tracking-tight ${size} ${className}`}>
      <span className={dark ? "text-slate-900" : "text-white"}>BBR</span>
      {withDot && <span className="text-gradient">.</span>}
      <span className="text-gradient">GO</span>
    </span>
  );
}
